export const FLAG_GETTING_PURCHASE_ORDERS = 'FLAG_GETTING_PURCHASE_ORDERS';
export const GET_PURCHASE_ORDERS = 'GET_PURCHASE_ORDERS';
export const CLEAR_PURCHASE_ORDERS = 'CLEAR_PURCHASE_ORDERS';
